import { createFileRoute } from '@tanstack/react-router';

import { Dashboard } from '@customer/features/dashboard';

export const Route = createFileRoute('/$venueSlug/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Dashboard />;
}
